<template>
  <div class="row">
    <div class="col-12">
      <raw-material-table />
    </div>
  </div>
</template>

<script>
import RawMaterialTable from "@/views/components/rawMaterials/table";
export default {
  name: "RawMaterialsList",
  components: { RawMaterialTable },
};
</script>
